import script from "./AdminAddPrayerMeetings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAddPrayerMeetings.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AdminAddPrayerMeetings.vue?vue&type=style&index=1&id=360c0fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360c0fc0"]])

export default __exports__